import PlatformRegisterScreen from './platform-register-screen.component';

export default PlatformRegisterScreen;
